import { BzDropdown, BzToolTip } from '../../components';
import { Container, Row, Col, Dropdown } from 'react-bootstrap';
import { _commaFormatter, _kFormatter } from '../../controllers';
import { FUNDS, FUNDS_CONFIG_KEYS } from '../../utils/global_variables';
import UtilisedAvailable from './UtilisedAvailable';
import { checkFundsConfigConditions } from '../../utils/global_functions';

const FundsBody = ({
  CustomDropdownToggle,
  allowedMarkets,
  isRefreshDisable,
  type,
  fundsConfig,
  activeMarket,
  handleFundsModalButton,
  activePeriodiciti,
  arrActivePeriodicities,
  handlePeriodicityChanges,
  handleParticulars,
  handleReportDropDown,
  handleMarketSelection,
  handleRefreshButton,
  modifiedPerdiocityBalanceAndType,
  kORCommaFormatter,
}) => {

  return (
    <Container fluid className={`p-0 ${type === 'watchlist' ? 'px-3' : ''}`}>
      <Row className={`g-0 ${type==='watchlist'?'mb-2':''}`}>
        <Col
          md={11}
          className={`d-flex justify-content-start align-items-center ${type!=='watchlist'&&'focus p-1'}`}
        >
          <div className={`font-medium color-text line-height-1 ${type==='watchlist'?'font-size6':'font-size9'}`}>
            Available Funds / Limits
          </div>
          {type!=='watchlist'&&<div data-testid="funds-modal-refresh-icon"
            className={`icon-16 icon-refresh icon-dark ms-2 ${
              isRefreshDisable ? 'icon-disabled' : null
            }`}
            onClick={handleRefreshButton}
          ></div>}
        </Col>
        <Col md={1} className="d-flex justify-content-end align-items-center">
          {checkFundsConfigConditions(fundsConfig,FUNDS_CONFIG_KEYS.CHECK_FOR_DROPDOWN) && <div className="add-funds-dropdown-wrapper">
            <BzDropdown data-testid="funds-modal-kebab-dropdown">
              <Dropdown.Toggle as={CustomDropdownToggle}>
                <BzToolTip placement={'bottom'} TooltipMsg={'More Options'}>
                  <div className="icon-20 icon-kebab icon-dark"></div>
                </BzToolTip>
              </Dropdown.Toggle>
              <Dropdown.Menu>
                {/* <Dropdown.Item key={FUNDS.MANDATE_REPORT} onClick={(e) => handleReportDropDown(FUNDS.MANDATE_REPORT)}>
                                            Mandate Report
                                        </Dropdown.Item>
                                        <Dropdown.Item key={FUNDS.REGISTER_MANDATE} onClick={(e) => handleReportDropDown(FUNDS.REGISTER_MANDATE)}>
                                            Register Mandate
                                        </Dropdown.Item> */}
                {checkFundsConfigConditions(fundsConfig,FUNDS_CONFIG_KEYS.RECENT_TRANSACTIONS) ? (
                  <Dropdown.Item
                    data-testid="funds-modal-kebab-recent-transactions-option"
                    key={FUNDS.RECENT_TRANSACTIONS}
                    onClick={() =>
                      handleReportDropDown(FUNDS.RECENT_TRANSACTIONS)
                    }
                  >
                    Recent Transactions
                  </Dropdown.Item>
                ) : null}
                {checkFundsConfigConditions(fundsConfig,FUNDS_CONFIG_KEYS.WITHDRAW_FUNDS) ? (
                  <Dropdown.Item
                    data-testid="funds-modal-kebab-withdraw-option"
                    key={FUNDS.WITHDRAWAL_FUNDS}
                    onClick={() =>
                      handleFundsModalButton(FUNDS.WITHDRAWAL_FUNDS)
                    }
                  >
                    Withdraw
                  </Dropdown.Item>
                ) : null}
                {allowedMarkets?.length > 1 && checkFundsConfigConditions(fundsConfig,FUNDS_CONFIG_KEYS.TRANSFER_FUNDS) ? (
                  <Dropdown.Item
                    data-testid="funds-modal-kebab-transfer-option"
                    key={FUNDS.TRANSFER_FUNDS}
                    onClick={() => handleFundsModalButton(FUNDS.TRANSFER_FUNDS)}
                  >
                    Transfer
                  </Dropdown.Item>
                ) : null}
                {checkFundsConfigConditions(fundsConfig,FUNDS_CONFIG_KEYS.ADD_FUNDS) ? (
                  <Dropdown.Item
                    data-testid="funds-modal-kebab-add-funds-option"
                    key={FUNDS.ADD_FUNDS}
                    onClick={() => handleFundsModalButton(FUNDS.ADD_FUNDS)}
                  >
                    Add Funds
                  </Dropdown.Item>
                ) : null}
              </Dropdown.Menu>
            </BzDropdown>
          </div>}
        </Col>
      </Row>
      <Row className={`g-0 ${type === 'watchlist' ? 'mb-2' : 'mt-3'}`}>
        <Col className="d-flex justify-content-start align-items-center add-funds-dropdown-wrapper">
          <Dropdown data-testid="funds-modal-periodicity-dropdown">
            {activePeriodiciti && Object.keys(activePeriodiciti)?.length ? (
              <Dropdown.Toggle as={CustomDropdownToggle}>
                <div className="d-flex justify-content-start align-items-center">
                  <div data-testid="funds-modal-periodicity-selected-item" className="font-medium font-size3 color-text line-height-1">
                    {activePeriodiciti?.name} {kORCommaFormatter('Total_Trading_Power_Limit','both')}
                  </div>
                  <div className="icon-14 icon-sort-down icon-dark ms-1"></div>
                </div>
              </Dropdown.Toggle>
        ) : null}
            <Dropdown.Menu data-testid="funds-modal-periodicity-dropdown-menu">
              {arrActivePeriodicities &&
                arrActivePeriodicities?.length &&
                arrActivePeriodicities?.map((eachProduct) => (
                  <Dropdown.Item
                  data-testid={`funds-modal-periodicity-dropdown-item-${eachProduct.id}`}
                    key={eachProduct.id}
                    onClick={() => {
                      handlePeriodicityChanges(eachProduct);
                    }}
                    value={eachProduct.id}
                  >
                    {eachProduct?.name} ₹{' '}
                    {_commaFormatter(
                      _kFormatter(
                        parseFloat(
                          eachProduct?.arrIndividualFundsItems
                            ?.Total_Trading_Power_Limit?.nTrading
                        )
                      )
                    )}
                  </Dropdown.Item>
                ))}
            </Dropdown.Menu>
          </Dropdown>
        </Col>
      </Row>
      <UtilisedAvailable kORCommaFormatter={kORCommaFormatter} type={type} activePeriodiciti={activePeriodiciti} handleParticulars={handleParticulars}/>
      <Row className={`g-0 ${type === 'watchlist' ? 'mb-2' : 'mt-3 d-flex'}`}>
        <Col>
          <div
            className={`d-flex justify-content-start align-items-center add-funds ${
              type === 'watchlist' ? 'horizontal-scroll-wrap' : 'x-scroll'
            }`}
          >
            {allowedMarkets?.length &&
              allowedMarkets?.map((each, index) => (
                <div
                  data-testid={`funds-modal-product-card-${each.sProductId || index}`}
                  key={index}
                  className={
                    each?.sProductId === activeMarket?.sProductId
                      ? 'addfunds-modal-radio-card active'
                      : 'addfunds-modal-radio-card'
                  }
                  onClick={() => handleMarketSelection(each)}
                >
                  <Row className="g-0">
                    <Col
                      className={`d-flex justify-content-end ${
                        type !== 'watchlist' && 'text-end'
                      }`}
                    >
                      <div className="icon-16 icon-portfolio icon-grey icon-faded"></div>
                    </Col>
                  </Row>
                  <Row
                    className={`g-0 ${type === 'watchlist' ? 'mb-2' : 'mb-1'}`}
                  >
                    <Col className="d-flex justify-content-start">
                      <div className="font-medium font-size4 color-text text-uppercase text-truncate">
                        {each.sProductName?.length > 12
                          ? `${each.sProductName?.slice(0, 11)}...`
                          : each.sProductName}
                      </div>
                    </Col>
                  </Row>
                  {checkFundsConfigConditions(fundsConfig,FUNDS_CONFIG_KEYS.ADD_FUNDS) ? (
                    <Row
                      className="g-0 py-1"
                      onClick={() => handleFundsModalButton('add funds')}
                    >
                      <Col className="d-flex justify-content-end align-items-center" data-testid={`funds-modal-product-card-add-funds-option-${each.sProductId || index}`}>
                        <div className="icon-16 icon-add-funds icon-dark me-2"></div>
                        <div className="font-regular font-size1 color-text">
                          Add Funds
                        </div>
                      </Col>
                    </Row>
                  ) : null}
                  {checkFundsConfigConditions(fundsConfig,FUNDS_CONFIG_KEYS.WITHDRAW_FUNDS)? (
                    <Row
                      className="g-0 py-1"
                      onClick={() => handleFundsModalButton('withdraw')}
                    >
                      <Col className="d-flex justify-content-end align-items-center" data-testid={`funds-modal-product-card-withdraw-funds-option-${each.sProductId || index}`}>
                        <div className="icon-16 icon-withdraw-funds icon-dark me-2"></div>
                        <div className="font-regular font-size1 color-text">
                          Withdraw Funds
                        </div>
                      </Col>
                    </Row>
                  ) : null}
                </div>
              ))}
          </div>
        </Col>
      </Row>
      <Row className={`${type === 'watchlist' ? 'g-0 mb-2' : 'mt-2'}`}>
        {(!fundsConfig?.newsummary
          ? activePeriodiciti
          : modifiedPerdiocityBalanceAndType
        )?.data?.map((each, i) => (
          <Col
           data-testid={`funds-modal-periodicity-balance-${i}`}
            md={type === 'watchlist' ? 12 : 6}
            key={i}
            onClick={() => handleParticulars(each)}
            className={`d-flex ${type === 'watchlist' && 'p-0'}`}
          >
            <Container
              fluid
              className={`${type === 'watchlist' ? 'px-2' : 'p-0'} py-1`}
            >
              <Row
                className={`g-0 ${
                  type === 'watchlist' && 'align-items-start justify-content-between'
                }`}
              >
                <Col md={type==='watchlist'? 5 : 6}
                  className={`d-flex justify-content-start ${
                    type !== 'watchlist' && 'align-items-start'
                  }`}
                >
                  <div className="font-medium font-size1 color-subtext">
                    {each?.sDescription}
                  </div>
                </Col>
                {type==='watchlist'?<Col md={2}></Col>:null}
                <Col md={type==='watchlist'? 5 : 6}
                  className={`d-flex justify-content-end ${
                    type == 'watchlist'
                      ? 'align-items-center'
                      : 'align-items-start text-end'
                  }`}
                >
                  {type === 'watchlist' ? (
                    <>
                      <div className="font-regular font-size2 color-text text-nowrap">
                        {parseFloat(each?.nTrading)
                          ? _commaFormatter(
                              _kFormatter(parseFloat(each?.nTrading).toFixed(2))
                            )
                          : '0.00'}
                      </div>
                      <div className="icon-10 icon-arrowright icon-dark flex-shrink-0"></div>
                    </>
                  ) : (
                    <div className="d-flex align-items-center">
                      <div className="font-regular font-size2 color-text">
                        {parseFloat(each?.nTrading)
                          ? _commaFormatter(
                              _kFormatter(parseFloat(each?.nTrading).toFixed(2))
                            )
                          : '0.00'}
                      </div>
                      <div className="icon-10 icon-arrowright icon-dark flex-shrink-0"></div>
                    </div>
                  )}
                </Col>
              </Row>
            </Container>
          </Col>
        ))}
      </Row>
      {/* // Ravi R - BREEZE:367 : 13/03/2025 Condition for newSummary Alternative Fund Summary based on Configuration : Start */}
      {!fundsConfig?.newsummary && (
        <Row
          className={`${
            type === 'watchlist' ? 'g-0 mb-2 bdr-top' : 'bdr-top py-2 mt-2'
          }`}
        >
          <Col md={type === 'watchlist' ? 12 : 6} className={`${type === 'watchlist' ? 'ps-2' : 'd-flex'}`}>
            <Container fluid className="p-0 py-1">
              <Row className="g-0">
                <Col className="d-flex justify-content-start align-items-start">
                  <div
                    data-testid="funds-modal-total-trading-label"
                    className="font-medium font-size1 color-subtext"
                  >
                    Total trading
                  </div>
                </Col>
                <Col className="d-flex justify-content-end align-items-start text-end">
                  <div className="d-flex align-items-center">
                    <div className="font-medium font-size2 color-text">
                      {kORCommaFormatter('Total_Trading_Power_Limit', 'both')}
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </Col>
          <Col md={type === 'watchlist' ? 12 : 6} className={`${type === 'watchlist' ? 'ps-2' : 'd-flex'}`}>
            <Container fluid className="p-0 py-1">
              <Row className="g-0">
                <Col className="d-flex justify-content-start align-items-start">
                  <div className="font-medium font-size1 color-subtext" data-testid="funds-modal-total-utilize-label">
                    Total Utilize
                  </div>
                </Col>
                <Col className="d-flex justify-content-end align-items-start text-end">
                  <div className="d-flex align-items-center">
                    <div
                      className={`font-medium font-size2 color-text ${
                        parseFloat(
                          activePeriodiciti?.arrIndividualFundsItems
                            ?.Total_Utilization?.nTrading
                        )
                          ? 'color-negative'
                          : ''
                      }`}
                    >
                      {kORCommaFormatter('Total_Utilization', 'both')}
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </Col>
          <Col md={type === 'watchlist' ? 12 : 6} className={`${type === 'watchlist' ? 'ps-2' : 'd-flex'}`}>
            <Container fluid className="p-0 py-1">
              <Row className="g-0">
                <Col className="d-flex justify-content-start align-items-start">
                  <div className="font-medium font-size1 color-subtext" data-testid="funds-modal-multiplier-label">
                    Multiplier:
                  </div>
                </Col>
                <Col className="d-flex justify-content-end align-items-start text-end">
                  <div className="d-flex align-items-center">
                    <div className="font-medium font-size2 color-text">
                      {kORCommaFormatter('Multiplier', 'both')}
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </Col>
          <Col md={type === 'watchlist' ? 12 : 6} className={`${type === 'watchlist' ? 'ps-2' : 'd-flex'}`}>
            <Container fluid className="p-0 py-1">
              <Row className="g-0">
                <Col className="d-flex justify-content-start align-items-start">
                  <div className="font-medium font-size1 color-subtext" data-testid="funds-modal-net-available-label">
                    Net Available
                  </div>
                </Col>
                <Col className="d-flex justify-content-end align-items-start text-end">
                  <div className="d-flex align-items-center">
                    <div
                     className={`font-medium font-size2 color-text ${parseFloat(
                        activePeriodiciti?.arrIndividualFundsItems
                          ?.Net_Available_Funds?.nTrading
                      ) > 0
                        ? 'color-positive'
                        : parseFloat(
                          activePeriodiciti?.arrIndividualFundsItems
                            ?.Net_Available_Funds?.nTrading
                        ) < 0 ? 'color-negative' : ''
                        }`}
                    >
                      {kORCommaFormatter('Net_Available_Funds', 'both')}
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
          </Col>
        </Row>
      )}
    </Container>
  );
};
export default FundsBody;
